import {identifyOS, identifyDesktop, isChrome} from "../helper/identifyOS"

export default {
  methods: {
    // native share
    nativeShare (photoId, caption) {
      if (navigator.share) {
        navigator.share({
          title: 'with a view',
          text: 'Share beautiful views !',
          url: `https://app.withaview.co/ext?id=${photoId}`,
        })
          .then(() => {
            console.log('Successful share')
            vm.$store.commit('snackbar_alert', {
              msg: 'Successful share'
            })
          })
          .catch((error) => {
            console.log('Error sharing', error)
            vm.$store.commit('snackbar_alert', {
              msg: 'Error sharing' + error
            })
          });
      }
      else {
        console.log(`share not avaailable.`)
        this.$store.state.gen.sheet = true
      }
    },
    // /native share
    // share
    share (photoId, caption) {
      console.log(`calling share`, photoId, caption)
      this.$store.state.gen.share_photoId = photoId
      this.$store.state.gen.share_caption = caption
      if (identifyOS() === `Android`) {
        //alert('isCrome=>', isChrome())
        if (isChrome()) {
          this.nativeShare(photoId, caption)
        }
        else {
          this.$store.state.gen.sheet = true
        }
      }
      else {
        this.$store.state.gen.sheet = true
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/share.js